module.exports = __webpack_public_path__ + "static/media/james2.c99b8190.mp3";